import { render, staticRenderFns } from "./wishlistConfirm.vue?vue&type=template&id=079f1040"
import script from "./wishlistConfirm.vue?vue&type=script&lang=js"
export * from "./wishlistConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports